import * as React from "react";
const SvgFiRrSalad = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-salad_svg__a)">
      <path
        fill="#062147"
        d="M23.194 11.6a3.94 3.94 0 0 0-2.143-1.447 21.6 21.6 0 0 0 .922-3.731 3.008 3.008 0 0 0-3.4-3.392c-.126.017-.5.072-1.011.171A5 5 0 0 0 18 .968a1 1 0 1 0-2 .064c.017.483-.082.963-.289 1.4a3.9 3.9 0 0 0-.611-1.08A4 4 0 0 0 11.5.034 3.8 3.8 0 0 0 9.5.8 3.94 3.94 0 0 0 7.233.01a3.95 3.95 0 0 0-2.885.877A4.03 4.03 0 0 0 3 3.782a4.1 4.1 0 0 0 .73 2.466 4.95 4.95 0 0 0-1.7 4.288A3.97 3.97 0 0 0 .164 15.15a14.75 14.75 0 0 0 3.707 6.316A8.92 8.92 0 0 0 10.139 24h3.722c2.34.01 4.592-.9 6.267-2.534a14.74 14.74 0 0 0 3.708-6.316 4 4 0 0 0-.642-3.55m-4.343-6.59a1.013 1.013 0 0 1 1.139 1.142A20 20 0 0 1 18.975 10h-2.561l1.293-1.293a1 1 0 0 0-1.414-1.414L13.586 10h-1.549a3.43 3.43 0 0 1 .976-2.9c.427-.431 2.064-1.6 5.838-2.09M5 3.849a2.03 2.03 0 0 1 .665-1.457A2.04 2.04 0 0 1 7.1 2.006a1.75 1.75 0 0 1 1.328.531 1.44 1.44 0 0 0 1.072.479 1.44 1.44 0 0 0 1.068-.482 1.64 1.64 0 0 1 1.156-.513 2.03 2.03 0 0 1 1.828.6c.304.389.462.871.448 1.364v.207a6.45 6.45 0 0 0-3.228 2.563 4.92 4.92 0 0 0-5.284-1.5A2.06 2.06 0 0 1 5 3.849M4 10a3 3 0 0 1 6 0zm17.916 4.589a12.9 12.9 0 0 1-3.2 5.46A6.9 6.9 0 0 1 13.861 22h-3.722a6.9 6.9 0 0 1-4.857-1.951 12.9 12.9 0 0 1-3.2-5.46 2.02 2.02 0 0 1 .324-1.789A1.98 1.98 0 0 1 4 12h16a1.98 1.98 0 0 1 1.6.8 2.02 2.02 0 0 1 .316 1.789"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-salad_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSalad;
